import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgKantoor = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#85E3F9"
      fillRule="evenodd"
      d="M35 10v18H23v3h6v3H11v-3h6v-3H5V10z"
      clipRule="evenodd"
    />
    <path
      fill="#00C5F2"
      d="M32 13H8v12h24z"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgKantoor);

export default ForwardRef;
